<template>
  <div class="app-activate-auto-top-up-summary">
    <slot name="txtBefore"></slot>
    <CurrentAutoTopUp :top-up="topUp">
      <template slot="txtThresholdAutoTopUp">
        <div class="top-up-title">Guthabengesteuerte Aufladung:</div>
        <div class="top-up-text">Unterschreitet dein FYVE Guthaben die gewählte Guthabengrenze, wird der gewählte Aufladebetrag automatisch auf dein FYVE Konto aufgeladen.</div>
      </template>
      <template slot="txtMonthlyAutoTopUp">
        <div class="top-up-title">Datumgesteuerte Aufladung:</div>
        <div class="top-up-text">Jeweils am 2. eines Monats wird der unten ausgewählte Aufladebetrag auf dein FYVE Konto aufgeladen.</div>
      </template>
    </CurrentAutoTopUp>
    <b-row class="top-up-trigger-row" v-if="topUp.type === 'byLimit'">
      <b-col cols="12" class="top-up-label">Guthabengrenze:</b-col>
      <b-col cols="12" class="top-up-amount">{{ formattedTrigger }}</b-col>
    </b-row>
    <b-row class="top-up-amount-row">
      <b-col cols="12" class="top-up-label">Aufladebetrag:</b-col>
      <b-col cols="12" class="top-up-amount">{{ formattedAmount }}</b-col>
    </b-row>
    <b-row class="single-topup-payment-type" v-if="payment.type">
      <b-col cols="12" md=""><label><slot name="lblPaymentType">Ihre Zahlungsart:</slot></label></b-col>
      <b-col cols="12" md="">
        <span class="payment-type" v-if="isBankAccount">
          <slot name="lblTypeBank">Lastschrift</slot>
      </span>
        <span class="payment-type" v-if="isCreditCard">
          <slot name="lblTypeCredit">Kreditkarte</slot>
      </span>
      </b-col>
    </b-row>
    <PaymentInformation :payment="payment">
      <template v-for="slot in possibleChildSlotsFor('Payment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PaymentInformation>
    <div class="change-payment-info">
      <b-button :href="url" class="btn-add-payment-information">
        <slot name="txtBtnChangePayment">Zahldaten ändern</slot>
      </b-button>
    </div>
    <Stepper
      @next="next()"
      @prev="prev()"
      :loading-next="loading"
      :loading-prev="loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import slotProxy from '@/mixins/slotProxy'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CurrentAutoTopUp from '@/components/process/generic/TopUp/ChangeAutoTopUp/fyve/CurrentAutoTopUp.vue'
import configBasedTopUpPrice from '@/mixins/configBasedTopUpPrice'
import Stepper from '@/components/generic/Stepper.vue'
import PaymentInformation from '@/components/process/generic/Payment/PaymentInformation.vue'

export default {
  name: 'ActivateAutoTopUpSummary',
  components: { PaymentInformation, CurrentAutoTopUp, Stepper },
  computed: {
    formattedTrigger: function () {
      if (this.topUp === null || this.topUp.trigger === null) {
        return 0
      }
      return this.price(this.topUp.trigger)
    },
    formattedAmount: function () {
      if (this.topUp === null || this.topUp.amount === null) {
        return 0
      }
      return this.price(this.topUp.amount)
    },
    isCreditCard () {
      return this.payment.type === 'creditCard'
    },
    isBankAccount () {
      return this.payment.type === 'bankAccount'
    },
    ...mapGetters('topUp/auto', {
      topUp: 'selectedTopUpData'
    })
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async next () {
      this.loading = true
      await this.changeAutoTopUp({ nextStep: 'success' })
      this.loading = false
    },
    ...mapActions('topUp/auto', [
      'changeAutoTopUp'
    ]),
    ...mapMutations('topUp/auto', [
      'changeStep'
    ]),
    prev () {
      this.changeStep({ step: 'amountSelect' })
    }
  },
  mixins: [
    configBasedTopUpPrice,
    slotProxy()
  ],
  props: {
    url: {
      type: String,
      default: '/'
    },
    payment: {
      type: Object
    }
  }
}
</script>
